import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMapContext } from '../context/MapContext';

const SampleData = ({ showStatus }) => {
  const { t } = useTranslation();
  const { loadGeoJSON } = useMapContext();
  const [loading, setLoading] = useState(false);
  
  // Sample data options
  const sampleFiles = [
    { value: 'P059_wgs84.geojson', label: t('sampleData.parliamentFile') }
  ];
  
  // Handle loading sample data
  const handleLoadSample = (filename) => {
    if (!filename) {
      showStatus(t('sampleData.messages.selectFile', 'Please select a sample file'), 'info');
      return;
    }
    
    setLoading(true);
    showStatus(t('sampleData.messages.loading', 'Loading sample data...'), 'info');
    
    fetch(`${process.env.PUBLIC_URL}/${filename}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        loadGeoJSON(data);
        // Show success message with count of features loaded
        const featureCount = data.features ? data.features.length : 0;
        showStatus(t('sampleData.messages.loadSuccess', { count: featureCount }), 'success');
      })
      .catch(error => {
        console.error('Error loading sample data:', error);
        showStatus(t('sampleData.messages.loadError'), 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  // Handle file upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const geojsonData = JSON.parse(e.target.result);
        if (geojsonData && geojsonData.type === 'FeatureCollection') {
          loadGeoJSON(geojsonData);
          const featureCount = geojsonData.features ? geojsonData.features.length : 0;
          showStatus(t('sampleData.messages.loadSuccess', { count: featureCount }), 'success');
        } else {
          showStatus(t('sampleData.messages.invalidFormat', 'Invalid GeoJSON format'), 'error');
        }
      } catch (error) {
        console.error('Error parsing GeoJSON:', error);
        showStatus(t('sampleData.messages.parseError', 'Error parsing GeoJSON file'), 'error');
      }
    };
    
    reader.readAsText(file);
  };
  
  return (
    <div>
      <div className="control-group">
        <label className="control-label">{t('sampleData.loadSample')}:</label>
        <div className="input-group">
          <select
            className="form-control"
            onChange={(e) => handleLoadSample(e.target.value)}
            disabled={loading}
          >
            <option value="">-- {t('sampleData.selectParliament', 'Select available Parliament')} --</option>
            {sampleFiles.map((file, index) => (
              <option key={index} value={file.value}>
                {file.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="control-group">
        <label className="control-label">{t('toolbar.importGeoJSON')}:</label>
        <div className="file-input-wrapper">
          <label className="file-input-button">
            {t('sampleData.browseFiles', 'Browse Files')}
            <input 
              type="file" 
              accept=".geojson,.json" 
              onChange={handleFileUpload}
              disabled={loading}
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default SampleData;
